export const colors: any = [
    '#0c26ea',
    '#0072ff',
    '#28475c',
    '#43a2e4',
    '#009f7b',
    '#138a00',
    '#57e600',
    '#797d04',
    '#6ccc05',
    '#d80979',
    '#ff0066',
    '#ff00e4',
    '#91048f',
    '#645ba8',
    '#6a7787',
    '#794915',
    '#cb6706',
    '#ff8400',
    '#c7504d',
    '#e92010'
]
    ;

export const statusClass: any = [
    {
        'name': 'Available',
        'color': 'available-list'
    },

    {
        'name': 'Allocated',
        'color': 'allocated-list'
    },
    {
        'name': 'Accepted',
        'color': 'accepted-list'
    },
    {
        'name': 'Completed',
        'color': 'completed-list'
    }
]


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/utils/color.ts